import { PaymentMethodType } from '@energy-retailer/constants';
import { z } from 'zod';

import { validateBsb } from '../../utils/validate-bsb';

export const directDebitSchema = z.object({
  paymentType: z.literal(PaymentMethodType.DirectDebit),
  accountName: z
    .string()
    .min(1, 'Account name is required')
    .regex(
      /^[a-z\d\-.,&()/\s]+$/i,
      'Account name should only contain alphanumeric characters, spaces and .,/&()-'
    ),
  bsb: z
    .string()
    .regex(/^\d{3}-\d{3}$/, 'BSB should contain 6 digits')
    .refine((value) => validateBsb(value), 'Could not find associated bank'),
  accountNumber: z
    .string()
    .min(6, 'Account number be at least 6 digits')
    .max(9, 'Account number cannot exceed 9 digits')
    .regex(/^\d+$/, 'Account number can only contain digits'),
});

export type DirectDebitSchema = z.infer<typeof directDebitSchema>;
